import { __assign, __rest, __spreadArray } from "tslib";
// DS8.1.3
// DS8.1.3M - M - variant: vertical - but designers use it for desktop too
import React from 'react';
import ModalRoot from '../../ModalRoot';
import ModalDoNotShowAgain from '../../ModalDoNotShowAgain';
import HorizontalLayout from './layouts/HorizontalLayout';
import VerticalLayout from './layouts/VerticalLayout';
var MessageModal = function (_a) {
    var variant = _a.variant, title = _a.title, message = _a.message, image = _a.image, footerButtons = _a.footerButtons, doNotShowAgainText = _a.doNotShowAgainText, onDoNotShowAgainChange = _a.onDoNotShowAgainChange, rest = __rest(_a, ["variant", "title", "message", "image", "footerButtons", "doNotShowAgainText", "onDoNotShowAgainChange"]);
    return (
    // TODO: cleanup `as any` with the `modals_match_theme` feature
    React.createElement(ModalRoot, __assign({ isFullscreen: false }, rest), variant === 'horizontal' ? (React.createElement(HorizontalLayout, { image: image, title: title, message: message, footerLeft: [
            onDoNotShowAgainChange && (React.createElement(ModalDoNotShowAgain, { key: "dns", doNotShowAgainText: doNotShowAgainText || '', onDoNotShowAgainChange: onDoNotShowAgainChange })),
        ], footerRight: footerButtons })) : (React.createElement(VerticalLayout, { image: image, title: title, message: message, footerButtons: __spreadArray([
            onDoNotShowAgainChange && (React.createElement(ModalDoNotShowAgain, { key: "dns", doNotShowAgainText: doNotShowAgainText || '', onDoNotShowAgainChange: onDoNotShowAgainChange }))
        ], footerButtons, true) }))));
};
MessageModal.displayName = 'MessageModal';
export default MessageModal;
//# sourceMappingURL=MessageModal.js.map